module.exports = __webpack_public_path__ + "media/images/new_marketing/woman_on_phone-c824d67bd622b99af0c54d1ceeb95a8d9d808b4e3dd3914700bc54f7653c42d4.jpg";